import Head from 'next/head'
import { createGlobalStyle } from 'styled-components'

/*
This CSS resource incorporates links to font software which is the valuable copyrighted property
of Monotype and/or its suppliers. You may not attempt to copy, install, redistribute, convert, 
modify or reverse engineer this font software. Please contact Monotype with any questions regarding
Web Fonts: https://www.linotype.com
*/

export const IvarFonts = createGlobalStyle`
  @font-face {
    font-family: Ivar;
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/ivardisplay/ivardisplay-regular-webfont.woff2') format('woff2'),
      url('/fonts/ivardisplay/ivardisplay-regular-webfont.woff') format('woff')
  }

  @font-face {
    font-family: 'Ivar Headline';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/ivar/IvarHeadline-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'Ivar Headline';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/ivar/IvarHeadline-Medium.otf') format('opentype');
  }

  @font-face {
    font-family: 'Ivar Text';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/ivar/IvarText-Regular.otf') format('opentype');
  }

  @font-face {
    font-family: 'Ivar Text';
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/ivar/IvarText-Medium.otf') format('opentype');
  }
`

const HelveticaNeueFonts = createGlobalStyle`
    @font-face {
      font-family: 'Helvetica Neue';
      font-weight: 400;
      font-style: normal;
      font-display: swap; /* stop FOUT */
      src: local('Helvetica Neue'), local('HelveticaNeue'),
        url('/fonts/5664093/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2') format('woff2'),
        url('/fonts/5664093/08edde9d-c27b-4731-a27f-d6cd9b01cd06.woff') format('woff');
    }

    @font-face {
      font-family: 'Helvetica Neue';
      font-weight: 500;
      font-style: normal;
      font-display: swap; /* stop FOUT */
      src: local('Helvetica Neue Medium'), local('HelveticaNeue-Medium'),
        url('/fonts/5664103/240c57a0-fdce-440d-9ce3-85e0cb56f470.woff2') format('woff2'),
        url('/fonts/5664103/7802e576-2ffa-4f22-a409-534355fbea79.woff') format('woff');
    }

    @font-face {
      font-family: 'Helvetica Neue';
      font-weight: 700;
      font-style: normal;
      font-display: swap; /* stop FOUT */
      src: local('Helvetica Neue Bold'), local('HelveticaNeue-Bold'),
        url('/fonts/5664150/800da3b0-675f-465f-892d-d76cecbdd5b1.woff2') format('woff2'),
        url('/fonts/5664150/7b415a05-784a-4a4c-8c94-67e9288312f5.woff') format('woff');
    }

    @font-face {
      font-family: 'Helvetica Neue';
      font-weight: 700;
      font-style: italic;
      font-display: swap; /* stop FOUT */
      src: local('Helvetica Neue Bold Italic'), local('HelveticaNeue-BoldItalic'),
        url('/fonts/5664111/13ab58b4-b5ba-4c95-afde-ab2608fbbbd9.woff2') format('woff2'),
        url('/fonts/5664111/5018b5b5-c821-4653-bc74-d0b11d735f1a.woff') format('woff');
    }
`

const GlobalFonts = () => (
  <>
    <Head>
      <link
        rel="preload"
        href="/fonts/5664093/08b57253-2e0d-4c12-9c57-107f6c67bc49.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
    </Head>
    <HelveticaNeueFonts />
  </>
)

export default GlobalFonts
